import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import ListSubheader from '@mui/material/ListSubheader';
import { FormattedMessage } from 'react-intl';

import messages from '../messagesManageAccounts';
import inlineStyles from './accountGroupStyles';

const KeyIvrDetails = (props) => {
	const { values, handleKeyIvrAccountNameChange, errors } = props;

	return (
		<div>
			<ListSubheader style={inlineStyles.subHeader}>
				<FormattedMessage {...messages.lbKeyIvrDetails} />
			</ListSubheader>

			<TextField
				id="keyIvrAccountName"
				label={<FormattedMessage {...messages.lbKeyIvrAccountName} />}
				fullWidth
				value={values.keyIvrAccountName}
				onChange={handleKeyIvrAccountNameChange}
				error={!!errors.srtKeyIvrAccountName}
				helperText={errors.srtKeyIvrAccountName}
				variant="standard"
			/>
		</div>
	);
};

KeyIvrDetails.propTypes = {
	values: PropTypes.shape({
		keyIvrAccountName: PropTypes.string,
	}).isRequired,
	handleKeyIvrAccountNameChange: PropTypes.func.isRequired,
	errors: PropTypes.shape({
		srtKeyIvrAccountName: PropTypes.string,
	}).isRequired,
};

export default KeyIvrDetails;
